export default __webpack_public_path__ + "static/media/groundhog-day.febd59aa.jpg";